import React from 'react';

export default class EditIcon extends React.Component{
    constructor(props){
         super(props)
     }

     onClick(event){
        if(this.props.onClick) this.props.onClick(event);
     }

     render(){
        var cls='content-edit-icon'; 
        if(this.props.cls) cls+= ' ' + this.props.cls;
        if(this.props.active){
            return(
              <div>
                 <div className={cls} onClick={this.onClick.bind(this)} style={this.props.style}>
                    <i className="material-icons">create</i>
                 </div>
                 {this.props.children}
              </div>  
            );
        }else{
            return(
               <div className="hide"></div>
            );
        }
     }
}